import { env } from '@skin-seoul/env-utils';
import { createHttpClient } from './httpClient';
import type { FetchClient } from './types';

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/products', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */

let _client: FetchClient | null = null;

const createClient = (): FetchClient => {
  if (!_client) {
    const baseURL = env('NEXT_PUBLIC_ENV_SERVER_ORIGIN') || 'https://dev.skin-seoul.com/api';

    // Debug logging for environment context
    const isServer = typeof window === 'undefined';
    const hasGlobalEnv = typeof globalThis !== 'undefined' && !!(globalThis as any).__ENV;

    console.debug('[service/client] Creating HTTP client:', {
      isServer,
      hasGlobalEnv,
      baseURL,
      envSource: hasGlobalEnv ? 'globalThis.__ENV' : 'process.env or fallback',
    });

    _client = createHttpClient({
      baseURL,
      options: {
        credentials: 'include',
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  return _client;
};

// Proxy object that delegates all method calls to the lazily created client
// This ensures compatibility with both Next.js SSR and client-side environments
export const client: FetchClient = {
  get: (url: string, options?: any) => createClient().get(url, options),
  post: (url: string, options?: any) => createClient().post(url, options),
  put: (url: string, options?: any) => createClient().put(url, options),
  patch: (url: string, options?: any) => createClient().patch(url, options),
  delete: (url: string, options?: any) => createClient().delete(url, options),
};
